<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="1000px"
  >
    <v-card>
      <v-card-title>
        <span v-if="item.id">Cập nhật item#{{item.id}}</span>
        <span v-else>Thêm mới</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <v-container>
          <div v-if="errors_exist" class="row">
            <div class="col">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors">
                    <li :key="index">{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </div>
          </div>
          <v-row>
            <v-col cols="12">
              <v-toolbar flat>
                <v-btn
                  color="primary"
                  @click="before"
                  :disabled="history.length==0"
                >
                  <v-icon>mdi-menu-left</v-icon>
                  Quay lại
                </v-btn>
                <v-breadcrumbs :items="crumbs">
                  <template v-slot:item="{ item }">
                    <v-breadcrumbs-item>
                      <a href="#" @click.prevent="getItems(item, 'select')">
                        {{ item.name }}
                      </a>
                    </v-breadcrumbs-item>
                  </template>
                </v-breadcrumbs>
                <v-spacer/>
                <v-menu
                  v-model="newFolderMenu"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      class="mr-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-plus</v-icon>
                      Thư mục
                    </v-btn>
                  </template>
                  <v-card>
                    <v-text-field
                      v-model="folder.name"
                      label="Tên thư mục"
                      class="pa-2 require"
                      hide-details="auto"
                      solo
                    >
                      <template #append>
                        <v-btn
                          color="success"
                          @click="createFolder"
                        >
                          Thêm
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-card>
                </v-menu>
                <v-btn
                  color="primary"
                  dark
                  @click="onPickFile"
                >
                  <v-icon>mdi-upload</v-icon>
                  Tải lên
                </v-btn>
                <input 
                  type="file" 
                  @change="onFilePicked" 
                  class="d-none" 
                  ref="fileInput" 
                  accept="image/*"
                />
              </v-toolbar>
            </v-col>
          </v-row>
          <div 
            class="text-center" 
            v-if="loading"
          >
            <v-progress-circular
              indeterminate
              size="30"
            />
          </div>
          <v-row>
            <v-col
              cols="12"
              sm="auto"
              v-for="(folder, index) in folders"
              :key="`folder${index}`"
            >
              <a href="#" @click.prevent="getItems(folder)">
                <div class="d-flex flex-column align-center">
                  <v-icon size="70">mdi-folder-outline</v-icon>
                  <p class="mb-0">{{folder.name}}</p>
                </div>
              </a>
            </v-col>
            <v-col
              cols="12"
              sm="auto"
              v-for="(image, index) in images"
              :key="`image${index}`"
            >
              <div class="d-flex flex-column align-center">
                <v-img
                  :src="`${apiBaseUrl}/uploads/${image.path}`"
                  width="70"
                  height="70"
                  contain
                />
                <p class="mb-0">{{image.path}}</p>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Đóng lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { mapState, mapActions } from 'vuex';
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {}
    },
    data () {
      return {
        newFolderMenu: false,
        items: [
          {
            text: 'Dashboard',
            disabled: false,
            href: 'breadcrumbs_dashboard',
          },
          {
            text: 'Link 1',
            disabled: false,
            href: 'breadcrumbs_link_1',
          },
          {
            text: 'Link 2',
            disabled: true,
            href: 'breadcrumbs_link_2',
          },
        ],
        loading: false,
        dialog: false,
        errors_exist: false,
        errors: [],

        folders: [],
        images: [],
        currentFolder: null,
        crumbs: [],
        history: [],
        folder: {
          name: ''
        }
      }
    },
    computed: {
      ...mapState([
        'config'
      ]),
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    mounted() {
      this.dialog = this.showDialog;
      this.getItems();
    },
    watch: {
      showDialog() {
        this.dialog = false;
        if (this.showDialog) {
          this.dialog = true;
        }
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      getItems(folder=null, action=null){
        this.loading = true;
        this.folders = [];
        let url = 'api/v1/folders';
        if(action == 'back'){
          this.history.shift(this.currentFolder);
        }
        if(action='select'){}
        if(folder) {
          url = `api/v1/folders/${folder.id}`;
          this.currentFolder=folder;
          this.history.unshift(folder);
        }
        let crumbs = [...this.history];
        this.crumbs = crumbs.reverse();
        this.loading = true;
        axios.get(url)
          .then(response => {
            if(folder){
              this.folders = response.data.folders;
              this.images = response.data.images;
            } else {
              this.folders = response.data;
              this.getNoneFolderImages();
            }
            this.loading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getNoneFolderImages(){
        axios.get('api/v1/images-nofolder')
          .then((response) => {
            this.images=response.data;
          }).catch(function (error) {
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      },
      createFolder(){
        if(this.currentFolder){
          this.folder.parent_id = this.currentFolder.id;
        }
        axios.post('api/v1/folders', this.folder)
          .then((response) => {
            this.newFolderMenu=false;
            this.getItems(this.currentFolder);
          }).catch(function (error) {
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      },
      before(){
        this.getItems(null, 'back');
      },
      onPickFile () {
        this.$refs.fileInput.click();
      },
      onFilePicked (event) {
        const app = this;
        const file = event.target.files[0];

        const config = {
          headers: { 'content-type': 'multipart/form-data' }
        };

        let formData = new FormData();
        formData.append('file', file);
        formData.append('folder_id', app.currentFolder.id);

        axios.post('api/v1/images', formData, config)
          .then(function (response) {
            app.getItems(app.currentFolder);
          })
          .catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      }
    }
  }
</script>